export default __webpack_public_path__ + "static/media/78t.a20e56d4.jpg";